import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { MxNavigationBarActions } from "../store/ducks/components/NavigationBar/navigationBar";

/**
 * @typedef {Object} Options
 * @property {any[]} [deps=[]]
 *
 * @typedef {() => void} Callback Callback passado para o botão de voltar para a home da NavigationBar.
 */

/**
 * Callback executado ao clicar no botão de voltar para a home da NavigationBar.
 * @param {Callback} callback
 * @param {Options} [options={}]
 */
export function useUpdateOnGoHome(callback, options = {}) {
    const dispatch = useDispatch();
    const { deps } = Object.assign({}, { deps: [callback] }, options);

    useEffect(() => {
        dispatch(MxNavigationBarActions.onVoltarHome(callback));
        return () => {
            dispatch(MxNavigationBarActions.resetOnVoltarHome());
        };
    }, deps);
}
